module.exports = __webpack_public_path__ + "static/media/gb-wls.344dc57e.svg";